var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.343 0.835116C11.0197 0.835116 13.1995 3.01495 13.1995 5.69437L13.1994 7.13958C14.8267 7.70591 15.9973 9.25507 15.9973 11.0732V15.0048C15.9973 17.301 14.13 19.1683 11.8338 19.1683H4.82951C2.53326 19.1683 0.666016 17.301 0.666016 15.0048V11.0732C0.666016 9.25542 1.83616 7.70649 3.46295 7.1399L3.46359 5.69437C3.46909 4.37437 3.97967 3.15612 4.90092 2.24312C5.82309 1.3292 7.04042 0.800282 8.343 0.835116ZM11.8338 8.28468H4.82951C3.29135 8.28468 2.04101 9.53501 2.04101 11.0732V15.0048C2.04101 16.5429 3.29135 17.7933 4.82951 17.7933H11.8338C13.371 17.7933 14.6223 16.5429 14.6223 15.0048V11.0732C14.6223 9.53501 13.371 8.28468 11.8338 8.28468ZM8.33145 11.3333C8.71095 11.3333 9.01895 11.6413 9.01895 12.0208V14.0567C9.01895 14.4362 8.71095 14.7442 8.33145 14.7442C7.95195 14.7442 7.64395 14.4362 7.64395 14.0567V12.0208C7.64395 11.6413 7.95195 11.3333 8.33145 11.3333ZM8.34025 2.21012H8.32559C7.397 2.21012 6.52709 2.56762 5.86984 3.21937C5.208 3.87387 4.84226 4.74745 4.83859 5.67878L4.83776 6.90916H11.8237L11.8245 5.69437C11.8245 3.77303 10.2616 2.21012 8.34025 2.21012Z",
    fill: "#384971"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.09fc570fde6cd6ec147f9ba6f3bfe5b5.svg";
export { ForwardRef as ReactComponent };